export default "__VITE_ASSET__DdZs9pNR__"